import "./App.css";
import "./index.css"
import React from "react";
import Container from "./pages/Container";


function App() {
  return (
    <div className="mainContainer">
      <Container />
    </div>
  );
}

export default App;
